// router.js
import { createBrowserRouter } from 'react-router-dom';
import AppLayout from './App';
import AddTunePage from './pages/AddTunePage';
import SearchPage from './pages/SearchPage';
import SettingsPage from './pages/SettingsPage';
import TuneDetailPage from './pages/TuneDetailPage';
import SessionViewer from './pages/SessionViewer';
import EditTunePage from './pages/EditTunePage';
import SetsPage from './pages/SetsPage';
import EditSetPage from './pages/EditSetPage';
import SetDetailPage from './pages/SetDetailPage';
import EditSessionPage from './pages/EditSessionPage';
import { Navigate } from 'react-router-dom';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
children: [
  { path: '', element: <Navigate to='/search' replace /> },   // 👈 REQUIRED
  { path: 'add', element: <AddTunePage /> },
  { path: 'mytunes', element: <SearchPage /> },
  { path: 'search', element: <SearchPage /> },
  { path: 'sessions', element: <SessionViewer /> },
  { path: 'editsession/:sessionId', element: <EditSessionPage /> },
  { path: 'settings', element: <SettingsPage /> },
  { path: 'tune/:id', element: <TuneDetailPage /> },
  { path: 'edit/:id', element: <EditTunePage /> },
  { path: 'tune/:id/edit', element: <EditTunePage /> },
  { path: 'sets', element: <SetsPage /> },
  { path: 'sets/:id', element: <SetDetailPage /> },
  { path: 'sets/:id/edit', element: <EditSetPage /> },
  { path: '*', element: <Navigate to='/search' replace /> },
]
,
  },
]);

export default router;